<div class="view-shortcuts">
    <div *ngFor="let group of shortcutGroups" class="view-shortcuts__group">
        <h2 class="view-shortcuts__label text-bold">{{ group.label }}</h2>
        <table class="view-shortcuts__table">
            <tbody>
                <tr class="view-shortcuts__row" *ngFor="let shortcut of group.shortcuts">
                    <td class="view-shortcuts__cell view-shortcuts__cell--label">{{ shortcut.label }}</td>
                    <td class="view-shortcuts__cell view-shortcuts__cell--key">
                        <kbd class="view-shortcuts__key" *ngFor="let key of shortcut.keys">{{ key }}</kbd>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>